import { Body, Head, Html, Img, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers } from "utils";
import { IPotluck } from "interfaces";

// components
import { Footer, Footnote, Schedule } from "./components";

export type Props = {
  url: string;
  name: string;
  potluck: IPotluck;
};

export const Voting = ({
  url,
  name,
  potluck: { party_name, date, start_time, end_time },
}: Props) => {
  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img style={Styles.img} src={Helpers.getImage("email_voting.png")} />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>Hello {name},</Text>

          {/* paragraph */}
          <Text style={Styles.textBold}>
            Your potluck party,{" "}
            <Text style={{ ...Styles.text, display: "inline" }}>
              {party_name}
            </Text>
            , has sufficient wish list suggestions to start voting. Swipe right
            to your favourite dishes today!
          </Text>

          {/* party name */}
          <Text style={Styles.text}>{party_name}</Text>

          {/* schedule */}
          <Schedule date={date} startTime={start_time} endTime={end_time} />

          {/* paragraph */}
          <Text style={Styles.text}>
            You are invited to contribute to our potluck party, that's happening
            on{" "}
            <Text style={{ ...Styles.textBold, display: "inline" }}>
              {date} {start_time && ", " + start_time}{" "}
              {start_time && end_time && "—" + end_time}
            </Text>
          </Text>

          {/* paragraph */}
          <Text style={Styles.text}>
            Make a wish list and vote your favourite dishes so that everyone
            gets to enjoy what they would like!
          </Text>

          {/* button */}
          <Link href={url} style={Styles.button}>
            Start My Wish List
          </Link>

          {/* footnote */}
          <Footnote />
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
